import type { JSONSchemaProperties } from '@root/helpers/schema/types';

import type { ToggleGroupOption } from './InputToggleGroup/types';
import type { ElementSize } from './types';
export const ELEMENT_SIZES: Record<ElementSize, string | string[]> = { sm: 'h-8', md: 'h-10', lg: 'h-12' };
export const MAX_DROPDOWN_HEIGHT_PX = 384;

/**
 * Get select options as name/value pairs from schema object
 * For use in InputSelect and InputMultiSelect components
 */
export const getSelectOptions = (schemaObject: JSONSchemaProperties): Array<{ name: string; value: string }> => {
  // Handle oneOf format with const/title pairs
  const oneOf = schemaObject?.oneOf ?? schemaObject?.items?.oneOf;
  if (Array.isArray(oneOf)) {
    return oneOf.map((option: any) => ({
      name: option.title,
      value: option.const,
    }));
  }

  // Fallback to simple mapping where name = value
  const enumValues = schemaObject?.enum ?? schemaObject?.items?.enum ?? [];
  return enumValues.map((value: any) => ({
    name: value,
    value,
  }));
};

export const getToggleGroupOptions = (schemaObject: JSONSchemaProperties): Array<ToggleGroupOption> => {
  // Handle oneOf format with const/title pairs
  const oneOf = schemaObject?.oneOf ?? schemaObject?.items?.oneOf;
  if (Array.isArray(oneOf)) {
    return oneOf.map((option: any) => ({
      label: option.title,
      value: option.const,
    }));
  }

  // Fallback to simple mapping where name = value

  const enumValues = schemaObject?.enum ?? schemaObject?.items?.enum ?? [];
  return enumValues.map((value: any) => ({
    label: value,
    value,
  }));
};
